<template>
    <section :id="slug" class="section">
        <h2 class="section-title wine-title has-text-centered" v-html="wine.title"></h2>
        <h4 v-if="wine.subtitle" class="has-text-centered" v-text="wine.subtitle"></h4>
        <div class="columns product-description">
            <div class="column is-6">
                <img :src="wine.image+'?id=45124741'">
            </div>
            <div class="column is-6">
                <div v-html="wine.description"></div>
                <table class="table is-fullwidth">
                    <tbody>
                    <tr>
                        <th v-t="'collections.alcohol'"></th>
                        <td v-text="wine.alcohol"></td>
                    </tr>
                    <tr>
                        <th v-html="$t('collections.acidity')"></th>
                        <td v-text="wine.acidity"></td>
                    </tr>
                    <tr>
                        <th v-t="'collections.sugar'"></th>
                        <td v-text="wine.sugar"></td>
                    </tr>
                    <tr>
                        <th v-t="'collections.so2'"></th>
                        <td v-text="wine.so2"></td>
                    </tr>
                    <tr>
                        <th v-t="'collections.pressure'"></th>
                        <td v-text="wine.pressure"></td>
                    </tr>
                    </tbody>
                </table>
                <div class="product-button">
                    <router-link class="button" :to="{ name: $i18n.locale+'.contact' }" v-t="'collections.cta'"></router-link>
                    <a class="button" target="_blank" :href="'/PDF/'+wine.pdf+'.pdf'" v-t="'collections.downloads'"></a>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        props: ['wine', 'slug']
    }
</script>